var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Shape_1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "375px",
    height: "234px",
    viewBox: "0 0 375 234",
    enableBackground: "new 0 0 375 234",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#434A54",
    d: "M347.479-0.006H27.53c-15.201,0-27.524,12.273-27.524,27.413v22.082h374.997V27.407 C375.003,12.268,362.68-0.006,347.479-0.006z M0.006,206.588c0,15.139,12.323,27.413,27.524,27.413h319.949 c15.201,0,27.524-12.274,27.524-27.413V95.785H0.006V206.588z M278.669,132.945h54.743v17.361h-54.743V132.945z M42.209,132.945 h121.26v17.361H42.209V132.945z M42.209,169.038h65.753v17.361H42.209V169.038z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.0d731d1450eed9a6b5ca9a0499549b87.svg";
export { ForwardRef as ReactComponent };